import { Link, useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Button } from "./ui/button";
import { LogOut, LayoutDashboard, Users, Activity } from "lucide-react";

export const Layout = ({ children }) => {
  const { user, logout } = useAuth();
  const loc = useLocation();
  const nav = useNavigate();

  const isAdmin = user && user.role === "admin";

  const handleLogout = async () => {
    await logout();
    nav("/login");
  };

  const navItem = (to, icon, label, testId) => {
    const active = loc.pathname === to;
    return (
      <Link
        to={to}
        data-testid={testId}
        className={`flex items-center gap-2 px-3 py-2 text-sm font-medium tracking-tight border-l-2 transition-colors ${
          active
            ? "border-[#007AFF] text-white bg-white/5"
            : "border-transparent text-zinc-400 hover:text-white hover:bg-white/5"
        }`}
      >
        {icon}
        <span>{label}</span>
      </Link>
    );
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white flex">
      {/* Sidebar */}
      <aside className="w-60 border-r border-white/10 bg-[#0A0A0A] flex flex-col">
        <div className="px-5 py-5 border-b border-white/10">
          <div className="flex items-center gap-2">
            <div className="w-7 h-7 bg-[#007AFF] flex items-center justify-center text-white font-display font-bold text-sm">
              T
            </div>
            <div>
              <div className="font-display text-lg font-bold leading-none tracking-tight">TIPPADÓ</div>
              <div className="text-[10px] tracking-[0.2em] text-zinc-500 uppercase mt-0.5">Pro Terminal</div>
            </div>
          </div>
        </div>

        <nav className="flex flex-col py-4">
          {navItem("/dashboard", <LayoutDashboard size={16} />, "Mai Mérkőzések", "nav-dashboard")}
          {navItem("/slips", <Activity size={16} />, "Szelvények", "nav-slips")}
          {isAdmin && navItem("/admin", <Users size={16} />, "Admin Panel", "nav-admin")}
        </nav>

        <div className="mt-auto px-4 py-4 border-t border-white/10">
          <div className="text-xs text-zinc-500 mb-2 truncate" data-testid="current-user-email">
            {user?.email}
          </div>
          <Button
            variant="outline"
            size="sm"
            onClick={handleLogout}
            data-testid="logout-btn"
            className="w-full border-white/15 hover:bg-white/5 text-zinc-300 hover:text-white"
          >
            <LogOut size={14} className="mr-2" /> Kijelentkezés
          </Button>
        </div>
      </aside>

      {/* Main */}
      <main className="flex-1 overflow-auto">{children}</main>
    </div>
  );
};

export default Layout;
